import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/resinContent';
import type { Volume } from '../data/resinContent';
const SWATCH: Record<Volume['swatch'], string> = {
  blush: 'bg-blush',
  beige: 'bg-beige',
  mist: 'bg-mist',
  pearl: 'bg-pearl',
  ivory: 'bg-ivory-100'
};
export function VolumesSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="volumes-title" data-id="element-338" data-mp="7q7icauigt40">
      <div className="mx-auto max-w-6xl px-5" data-id="element-339" data-mp="3g5hhpb70nk83">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-340" data-mp="3c460nu27k7bi">
          What’s inside
        </p>
        <h2 id="volumes-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-341" data-mp="3pwlwoawoz52x">
          The 6 volumes
        </h2>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-342" data-mp="2xcdlbi2eyt9s">
          {volumes.map(v => <li key={v.number} className="flex flex-col border border-charcoal-600 bg-charcoal-900 p-5 sm:p-6" data-id="element-343" data-mp="2sdsto7189hwy">
              <div className="flex items-center gap-3" data-id="element-344" data-mp="2eebr4iwitr3v">
                <span className={`h-7 w-2 shrink-0 ${SWATCH[v.swatch]}`} aria-hidden="true" data-id="element-345" data-mp="2ecqwyue4ca6j" />
                <p className="text-[10px] font-semibold uppercase tracking-[0.26em] text-champagne" data-id="element-346" data-mp="2j5ts36yjnrou">
                  Volume {v.number}
                </p>
              </div>
              <h3 className="mt-3 font-display text-[1.45rem] font-semibold uppercase leading-tight text-ivory-50" data-id="element-347" data-mp="1qho8inj888ql">
                {v.title}
              </h3>
              <p className="mt-1 text-[12px] font-medium uppercase tracking-[0.1em] text-ivory-300" data-id="element-348" data-mp="20etzlvrubzqt">{v.subtitle}</p>
              <p className="mt-4 border-t border-charcoal-600 pt-4 text-[14px] leading-relaxed text-body" data-id="element-349" data-mp="24gxbummc38d5">{v.intro}</p>
              {v.items.length > 0 && <ul className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1.5" data-id="element-350" data-mp="3bw238eunxbtx">
                  {v.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-351" data-mp="1gqsy4ysuc60i">
                      <CheckIcon className="mt-1 h-3 w-3 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-352" data-mp="1gozrhji89lsi" />
                      <span className="text-[13px] leading-snug text-ivory-200" data-id="element-353" data-mp="1bu2gi71e12cz">{item}</span>
                    </li>)}
                </ul>}
            </li>)}
        </ul>
      </div>
    </section>;
}